/*
 * @创建文件时间: 2019-12-21 15:26:02
 * @Auther: lfq
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-22 20:53:18
 * @联系Qq:1638245306
 * @文件介绍: 养护单位管理
 */
export default [{
    path: 'muConstructionUnit',
    name: 'muConstructionUnit',
    meta: {
        title: '施工单位基本信息',
        auth: true
    },
    component: () =>
        import ('@/views/basic/maintenanceUnit/muConstructionUnit')
}, {
    path: 'muReviewMaterial',
    name: 'muReviewMaterial',
    meta: {
        title: '公路养护工程从业资质',
        auth: true
    },
    component: () =>
        import ('@/views/basic/maintenanceUnit/muReviewMaterial')
}, {
    path: 'tenderEvaluation',
    name: 'tenderEvaluation',
    meta: {
        title: '投标行为评定',
        auth: true
    },
    component: () =>
        import ('@/views/basic/maintenanceUnit/tenderEvaluation')
}, {
    path: 'muCreditRating',
    name: 'muCreditRating',
    meta: {
        title: '企业信用信息评定',
        auth: true
    },
    component: () =>
        import ('@/views/basic/maintenanceUnit/muCreditRating')
}]